import React, { useEffect, Suspense } from "react";
import TeamImg from "../../assets/team-people.svg";
import TeamShape from "../../assets/team-shapes.png";
import SineWaves from "sine-waves";
import { SuspenseImg } from "../../helpers/SuspenseImg";

const Team = () => {
  useEffect(() => {
    const waveAnimation = () => {
      // eslint-disable-next-line
      var waves = new SineWaves({
        el: document.getElementById("waves"),
        speed: 0.5,
        ease: "Linear",
        wavesWidth: "100%",
        waves: [
          {
            timeModifier: 1,
            lineWidth: 1,
            amplitude: -80,
            wavelength: 80,
            strokeStyle: "rgba(160, 76,255, .2)",
          },
          {
            timeModifier: 2,
            lineWidth: 1,
            amplitude: -40,
            wavelength: 80,
            strokeStyle: "rgba(76, 114,255, .3)",
          },
          {
            timeModifier: 1,
            lineWidth: 1,
            amplitude: -20,
            wavelength: 120,
            strokeStyle: "rgba(107, 167,255, .5)",
          },
          {
            timeModifier: 0.5,
            lineWidth: 1,
            amplitude: -80,
            wavelength: 80,
            strokeStyle: "rgba(107, 167,255, .2)",
          },
          {
            timeModifier: 0.25,
            lineWidth: 1,
            amplitude: -40,
            wavelength: 80,
            strokeStyle: "rgba(160, 76,255, .3)",
          },
        ],

        // Called on window resize
        resizeEvent: function () {
          var gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
          gradient.addColorStop(0, "rgba(76, 114, 255, 0.5)");
          gradient.addColorStop(0.5, "rgba(106, 76, 255, 1)");
          gradient.addColorStop(1, "rgba(76, 114, 255, 0.5)");

          var index = -1;
          var length = this.waves.length;
          while (++index < length) {
            //this.waves[index].strokeStyle = gradient;
          }

          // Clean Up
          index = void 0;
          length = void 0;
          gradient = void 0;
        },
      });
    };
    waveAnimation();
    window.addEventListener("resize", waveAnimation);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener("resize", waveAnimation);
    };
  }, []);
  return (
    <>
      <section>
        <div className="container sm:container md:container mx-auto pt-16">
          <div className="md:w-4/5 w-5/5	mx-auto">
            <h3 className=" brand-primary-gradient text-4xl font-semibold leading-normal text-center font-avenirHeavy">
              #team
            </h3>
            <p className="py-3 text-Gray-600 md:text-lg text-sm text-center font-opensans leading-relaxed">
              We’re very proud of the team we’ve built which is assembled from
              highly skilled experts and specialists in the industry. Working
              with different technologies and platforms, thanks to their
              qualities and creative work, complex problems are solved with a
              great success
            </p>
          </div>
        </div>
        <section className="relative mt-12">
          <canvas
            id="waves"
            style={{
              width: "100%",
              height: "200px",
              position: "absolute",
              zIndex: -1,
              top: "50%",
              marginTop: "-100px",
            }}
          ></canvas>
          <div className="container sm:container md:container mx-auto">
            <div className="md:w-3/5 w-5/5	mx-auto">
              <div className="relative">
                <Suspense fallback="Loading...">
                  <SuspenseImg
                    alt=""
                    className="absolute bottom-1.5 left-0 -z-1"
                    src={TeamShape}
                  />
                </Suspense>
                <Suspense fallback="Loading...">
                  <SuspenseImg alt="" src={TeamImg} />
                </Suspense>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Team;
